/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Metadata_LoadingInputs */



/**
* | output |
* | --- |
* | "Loading metadata…" |
*
* @param {Iconik_Metadata_LoadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_metadata_loading = /** @type {((inputs?: Iconik_Metadata_LoadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Metadata_LoadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Loading metadata…")
	if (locale === "de") return /** @type {LocalizedString} */ ("Loading metadata…")
	if (locale === "it") return /** @type {LocalizedString} */ ("Loading metadata…")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Loading metadata…")
	if (locale === "es") return /** @type {LocalizedString} */ ("Loading metadata…")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Loading metadata…")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Loading metadata…")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Loading metadata…")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Loading metadata…")
	return /** @type {LocalizedString} */ ("Loading metadata…")
});